// RUNN — waitlist submission. Writes to Firestore `waitlist` (public-create,
// validated by security rules). Degrades to a console stub with no backend.
import { backendLive } from './config.js';
import { detectRegionCode } from '../compliance/regions.js';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export async function joinWaitlist(email, marketingConsent) {
  const clean = String(email || '').trim().toLowerCase();
  if (!EMAIL_RE.test(clean)) return { ok: false, reason: 'invalid-email' };

  if (!backendLive) {
    console.info('[RUNN] waitlist (stub — no backend configured):', { email: clean, marketingConsent: !!marketingConsent });
    return { ok: true, stubbed: true };
  }

  const [{ addDoc, collection, serverTimestamp }, { db }] = await Promise.all([
    import('firebase/firestore'),
    import('./firebase.js'),
  ]);
  await addDoc(collection(db(), 'waitlist'), {
    email: clean,
    marketingConsent: !!marketingConsent,
    region: detectRegionCode() || 'XX',
    locale: navigator.language || 'en',
    source: 'landing',
    createdAt: serverTimestamp(),
  });
  return { ok: true };
}
